"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampleDrawType = void 0;
var SampleDrawType;
(function (SampleDrawType) {
    SampleDrawType[SampleDrawType["First Draw"] = 0] = "First Draw";
    SampleDrawType[SampleDrawType["Flush 30"] = 1] = "Flush 30";
    SampleDrawType[SampleDrawType["Flush 180"] = 2] = "Flush 180";
    SampleDrawType[SampleDrawType["Flush"] = 3] = "Flush";
})(SampleDrawType = exports.SampleDrawType || (exports.SampleDrawType = {}));
//# sourceMappingURL=SampleDrawType.js.map